(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.details-content').forEach(content => {
  const onlyChild = content.firstElementChild;

  if (
    content.children.length === 1 &&
    onlyChild.tagName === 'DIV' &&
    onlyChild.textContent.trim() === ''
  ) {
    const details = content.closest('details');
    if (details) details.style.display = 'none';
  }
});
  } catch(e) { console.error(e); }
})();

})();
